export default {
    'home_link': 'Let’s get you back to safety',

    'error.400.title': '400 Bad Request',
    'error.400.message': 'Something has gone wrong, double check what you were doing and try again',

    'error.401.title': '401 Unauthorized',
    'error.401.message': 'Looks like you are not authorized to complete this request',

    'error.403.title': '403 Restricted Access',
    'error.403.message': 'Looks like we cannot complete this request. Are you sure you have permission to do this? ',

    'error.404.title': '404 Page Not Found',
    'error.404.message': 'The page you are looking for was not found',

    'error.422.message': 'Please double check what you have entered and try again',

    'error.429.message': 'Looks like you are moving too fast, please wait a few seconds and try again.',

    'error.500.title': 'Something has gone wrong',
    'error.500.message': "It's not you, it's us, please wait few minutes and try again.",

    'error.503.title': '503 Service Unavailable',
    'error.503.message': 'Looks like we are overloaded, please try again in few minutes ',

    'error.general.title': 'Ooops',
    'error.general.message': 'Something has gone wrong, please try again in a few minutes. If you are still having problems please feel free to contact us.',

    'error.user_not_activated': "Looks like you haven't activated your account, in case you missed it we resent you activation email.",
};
